import { isFunction, isObject } from 'lodash-es';
import React from 'react';

export type ConnectionStats = Record<string, unknown> | undefined;

export function getConnectionStats(): ConnectionStats {
  const connection = (navigator as Navigator & { connection: unknown })
    ?.connection;

  if (isObject(connection)) {
    const result: Record<string, unknown> = {};
    for (const key in connection) {
      const value = connection[key as keyof typeof connection];
      if (isFunction(value)) continue;
      result[key] = value;
    }
    return result;
  } else {
    return undefined;
  }
}

function getDeviceOrientation() {
  if (window.screen && window.screen.orientation) {
    // New API (all major browsers and webviews)
    if (window.screen.orientation.type.startsWith('portrait')) {
      return 'portrait';
    } else {
      return 'landscape';
    }
  } else {
    // Fallback
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }
}

export function useDeviceOrientation() {
  const [isInPortraitMode, setIsInPortraitMode] = React.useState(
    getDeviceOrientation()
  );

  React.useEffect(() => {
    const handleOrientationChange = () => {
      setIsInPortraitMode(getDeviceOrientation());
    };

    window.addEventListener('orientationchange', handleOrientationChange);

    setIsInPortraitMode(getDeviceOrientation());

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return isInPortraitMode;
}
